<script setup>
import UpdatedPageRow from "@/components/kit-settings/partials/UpdatedPageRow.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import TabHeading from "@/components/kit-settings/partials/TabHeading.vue";
import axios from "axios";
import {useQuery} from "@tanstack/vue-query";

const {data: pages, isPending} = useQuery({
  queryKey: ['updated-pages'],
  queryFn: async () => {
    const {data} = await axios.get('/ajax/v2/seo-agent/updated-pages');

    return data.data;
  }
})
</script>

<template>
  <div class="tw-flex tw-flex-col tw-h-full tw-gap-8 tw-p-8 tw-w-full tw-border tw-border-neutral-300 tw-rounded-xl tw-bg-white tw-relative tw-overflow-scroll">
    <div class="tw-flex tw-flex-col tw-gap-4">
      <div class="tw-flex tw-justify-between tw-items-center">
        <TabHeading
          class="tw-h-12"
          icon="icons/calendar-check"
          heading="Updated Pages"
        />
      </div>

      <div class="tw-text-neutral-500">
        This is a list of pages I’ve already worked on, ordered by the date they were completed. If you don’t see a page in Available Pages, check here — it may already have been updated.
      </div>
    </div>

    <div
      v-if="pages?.length > 0 && !isPending"
      class="tw-flex tw-flex-col tw-gap-4 tw-h-full"
    >
      <UpdatedPageRow
        v-for="(page, index) in pages"
        :key="index"
        :url="page.url"
        :date="page.processed_at"
      />
    </div>

    <LoadingBlock v-else-if="isPending" />
    <ZeroContent v-else>
      No updated pages
    </ZeroContent>
  </div>
</template>
